import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { prismicImage } from 'src/common/utils/prismic-image';
import Tag from 'wonderbly-components/lib/Tag';

import './CardInput.scss';

const CardInput = props => {
  const checked = props.selectedValues.includes(props.value);

  return (
    <div
      className={cx(
        'CardInput',
        { 'CardInput--active': checked },
      )}
      key={props.value}>
      <input
        className="CardInput__input"
        type="checkbox"
        id={props.value}
        onChange={props.onHandleChange}
        value={props.value}
        checked={checked}
      />
      <label
        className="CardInput__label"
        htmlFor={props.value}>
        {props.image && (
          <div
            className="CardInput__image"
            style={{ backgroundImage: `url(${prismicImage(props.image)})` }}
          />
        )}
        <div className="CardInput__body">
          {props.title && (
            <h5 className="CardInput__title">
              {props.title}
            </h5>
          )}
          {props.description && (
            <p className="CardInput__description">
              {props.description}
            </p>
          )}
          {props.tag && (
            <div className="CardInput__footer">
              <Tag
                textColor={props.tagTextColor}
                backgroundColor={props.tagBackgroundColor}>
                {props.tag}
              </Tag>
            </div>
          )}
        </div>
      </label>
    </div>
  );
};

CardInput.propTypes = {
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  description: PropTypes.string,
  tag: PropTypes.string,
  tagTextColor: PropTypes.string,
  tagBackgroundColor: PropTypes.string,
  image: PropTypes.object,
  value: PropTypes.string.isRequired,
  onHandleChange: PropTypes.func.isRequired,
};

export default CardInput;
